import { Divider } from "antd";
import { BadgeCheck, Banknote } from "lucide-react";
import React from "react";

const SalaryCard = ({employee}) => {
  
  return (
    <div className="w-full rounded-lg border-2 border-form-bg border-t-[#231564] shadow-lg px-2 sm:px-3 py-2 sm:py-3 bg-white">
      {/* Header */}
      <div className="flex items-center gap-2 text-black font-semibold">
        <Banknote size={18} sm:size={20} className="text-gray-400" />
        <h2 className="text-sm sm:text-md font-bold">Salary</h2>
      </div>
      <Divider className="!p-0 !m-0" />

      {/* Grid Layout for Salary Details */}
      <div className="grid grid-cols-2 gap-y-2 sm:gap-y-3 text-sm sm:text-md mt-2">
        <span className="text-gray-400 text-[10px] sm:text-[11px] whitespace-nowrap">PAY PERIOD</span>
        <span className="whitespace-nowrap capitalize">{employee?.salary_type || 'N/A'}</span>

        <span className="text-gray-400 text-sm sm:text-md whitespace-nowrap">BASE SALARY</span>
        <span className="blur-xs hover:blur-none transition-all duration-150 ease-linear whitespace-nowrap">
          RS {employee?.monthly_salary?.toLocaleString() || '0'}
        </span>

        <span className="text-gray-400 text-sm sm:text-md whitespace-nowrap">ALLOWANCES</span>
        <span className="whitespace-nowrap">RS {employee?.allowance?.toLocaleString() || '0'}</span>

        <span className="text-gray-400 text-sm sm:text-md whitespace-nowrap">CONTRIBUTIONS</span>
        <span className="whitespace-nowrap">RS {employee?.contribution?.toLocaleString() || '0'}</span>

        <span className="text-gray-400 text-sm sm:text-md whitespace-nowrap">DEDUCTIONS</span>
        <span className="whitespace-nowrap">RS {employee?.deduction?.toLocaleString() || '0'}</span>

        <span className="text-gray-400 text-sm sm:text-md whitespace-nowrap">NET SALARY</span>
        <span className="blur-xs hover:blur-none transition-all duration-500 ease-out whitespace-nowrap">
          RS {employee?.overAll_salary?.toLocaleString() || '0'}
        </span>
      </div>
    </div>
  );
};

export default SalaryCard;
